<template lang="pug">
div
  //- Title
  .d-flex.justify-space-between
    .d-flex.align-center
      v-icon.mr-3(size="16") $yzi-pencil-line
      .text-md.font-semibold {{ $t('notes') }}
    template(v-if="isOwnNotes")
      v-hover(v-slot="{ hover }")
        .text-sm.font-semibold.underline.clickable.px-3.py-1.round-lg(:class="[{ 'neutral300':hover }]" @click="onEdit") {{ $t('edit') }}
  v-divider.mt-2.mb-4.neutral500
  //- Content
  template(v-for="item in items")
    v-row.mb-4(no-gutters)
      v-col(cols="2")
        .text-sm.font-semibold {{ item.text }}
      v-col.text-left
        .d-flex
          .text-sm.font-semibold.mr-3 :
          template(v-if="item.value === 'note'")
            .text-sm(v-html="consultation[item.value] || '-'")
          template(v-else)
            .text-sm {{ consultation[item.value]  || '-' }}
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    consultation: {
      type: Object,
      default: () => {
        return {}
      }
    },
    provider: {
      type: Object,
      default: null
    },
    leadPid: {
      type: String,
      required: true
    },
    patientId: {
      type: Number,
      default: null
    },
    page: {
      type: Number,
      default: null
    },
    source: {
      type: String,
      default: 'patient-profile'
    }
  },
  data() {
    return {
      items: [
        {
          text: 'Visit notes',
          value: 'case'
        },
        {
          text: 'Case notes',
          value: 'note'
        },
      ]
    }
  },
  computed: {
    ...mapState('user', ['member']),
    isOwnNotes () {
      if (this.member.roles.includes('Agent') && this.provider) {
        return this.member.provider === this.provider.id
      }

      return false
    }
  },
  methods: {
    onEdit () {
      if (this.source === 'patient-history') {
        this.$router.push(`/admin/clinic/consultation/${this.leadPid}/note-fullview?origin=patient-history&page=${this.page}&leadPid=${this.leadPid}`)
      } else {
        this.$router.push(`/admin/clinic/consultation/${this.leadPid}/note-fullview?origin=patient-profile&patientId=${this.patientId}&leadPid=${this.leadPid}`)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>